import React from "react";

const Paragraph = () => {
  return (
    <div>
      <div>
        <p>
          I am <span>Suman Kumar Maharana</span> alias <span>KiRa</span>. I am a
          self taught <span>web developer</span>. Since being in my
          journey I have choosen the path <span>web developing</span>. Web is
          like ocean it is a never ending <span>creativity</span>. Learning web
          development is lot more <span>challenging</span> than it is used to
          be. It's full of new <span>creativity</span> and I do{" "}
          <span>love creativity</span> & I am part of it now. I'm quietly{" "}
          <span>confident</span>, naturally <span>curious</span>, and{" "}
          <span>perpetually</span> working on improving my chops one design
          problem at a time. I like to code things from <span>scratch</span>,
          and enjoy bringing <span>ideas</span> to life in the browser.
        </p>
      </div>
    </div>
  );
};

export default Paragraph;
